import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const CHANGE_ROLE = gql`
  mutation changeUserFarmRole($farmId: String!, $userIds: [String!]!, $newRole: String!) {
    changeUserFarmRole(farmId: $farmId, userIds: $userIds, newRole: $newRole) {
      id
      myRole
      users {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;

const DELETE_USER = gql`
  mutation deleteUserFromFarm($farmId: String!, $userIds: [String!]!) {
    deleteUserFromFarm(farmId: $farmId, userIds: $userIds) {
      id
      myRole
      users {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;

export type ChangeRoleFn = (userIds: string[], newRole: string) => void;
export type DeleteUserFn = (userIds: string[]) => void;

interface Props {
  farmId: string;
  onCompleted: (farm: Farm) => void;
  children: (
    changeRoleFn: ChangeRoleFn,
    deleteUserFn: DeleteUserFn,
    loading: boolean
  ) => React.ReactNode;
}

const NewFarmProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={CHANGE_ROLE}
      onCompleted={data => props.onCompleted(data.changeUserFarmRole)}
    >
      {(changeRoleFn, changeRoleResult) =>
        <AuthorizedMutation
          mutation={DELETE_USER}
          onCompleted={data => props.onCompleted(data.changeUserFarmRole)}
        >
          {(deleteUserFn, deleteUserResult) =>
            props.children(
              (userIds: string[], newRole: string) =>
                changeRoleFn({
                  variables: {
                    farmId: props.farmId,
                    userIds,
                    newRole
                  }
                }),
              (userIds: string[]) =>
                deleteUserFn({
                  variables: {
                    farmId: props.farmId,
                    userIds
                  }
                }),
              changeRoleResult.loading || deleteUserResult.loading
            )
          }
        </AuthorizedMutation>
      }
    </AuthorizedMutation>
  );
};

export default NewFarmProvider;



// WEBPACK FOOTER //
// ./src/providers/FarmUsersProvider.tsx